<template>
  <div>
    <!-- Bannière -->
    <div class="banner">
      <div class="banner-content">
        <h1>Bienvenue sur mon PORTFOLIO</h1>
        <p>
          Découvrez les projets auxquels j'ai pu participer et réaliser au cours de ma formation en BUT Métiers du Multimédia et de l'Internet.
        </p>
        <button @click="scrollToProjects">En savoir plus</button>
      </div>
    </div>

    <!-- Section des projets -->
    <div class="nav-container" ref="projectsSection">
      <!-- Navigation classique -->
      <div class="navigation desktop-navigation">
        <div class="links-container" ref="linksContainer">
          <router-link
            v-for="(route, index) in routes"
            :key="index"
            active-class="active"
            class="link"
            :class="{ active: $route.path === route.path }"
            :to="route.path"
            @click="handleClick($event, route.path)"
          >
            <img :src="getPictogram(route.name)" :alt="`${route.name} icon`" class="pictogram" />
            <h3>{{ route.name }}</h3>
          </router-link>
          <div class="animated-border" ref="animatedBorder"></div>
        </div>
      </div>

      <!-- Navigation responsive -->
      <div class="navigation mobile-navigation">
        <div class="mobile-links-container">
          <router-link
            v-for="(route, index) in routes"
            :key="index"
            active-class="active"
            class="link mobile-link"
            :class="{ active: $route.path === route.path }"
            :to="route.path"
            @click="handleClick($event, route.path)"
          >
            <img :src="getPictogram(route.name)" :alt="`${route.name} icon`" class="pictogram" />
          </router-link>
        </div>
      </div>
    </div>

    <transition
      mode="out-in"
      :name="transitionDirection === 'forward' ? 'slide-left' : 'slide-right'"
    >
      <RouterView />
    </transition>
  </div>
</template>

<style scoped>

/* .router-enter-active,
.router-leave-active {
  transition: 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.router-enter-from,
.router-leave-to {
  opacity: 0;
  transform: translateY(50px) scale(0.8);
} */

.slide-left-enter-active,
.slide-right-enter-active,
.slide-left-leave-active,
.slide-right-leave-active {
  transition: all 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.slide-left-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to,
.slide-right-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-left-enter-to,
.slide-right-enter-to,
.slide-left-leave-from,
.slide-right-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.link {
  position: relative;
  padding: 0.5rem 0.1rem;
  text-decoration: none;
  color: inherit;
  display: flex;
  width: -webkit-fill-available;
  align-items: center;
  justify-content: center;
  transition: color 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94), background 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.animated-border {
  position: absolute;
  bottom: 0;
  height: 2px;
  width: 0;
  background-color: var(--yellow-white);
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94); /* Transition fluide */
  pointer-events: none;
}

.active h3{
  opacity: 1 !important;
  color:var(--yellow-white);
}

.link h3 {
  font-family: var(--font-title);
  letter-spacing: -0.5px;
  font-weight: 700;
  transition: 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  margin:1vw; 
  text-wrap: nowrap; 
  opacity: 0.7;
}

.link:hover h3 {
  opacity: 1;
  color:var(--yellow-white);

}

.link:hover{
  background: var(--gray-hover);
}

.nav-container{
    display: flex;
    justify-content: center;
    margin-top: 4rem;
}

.navigation .links-container{
  width: 100%;
    display: flex;
    position: relative;
}

.search-container{
    display: flex;
    align-items: center;
    gap:1vw;
}

.navigation{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap:2vw;
    overflow: hidden;
    background: var(--hard-blue);
    box-shadow: var(--box-shadow-1);
}

.banner {
    width: 100%;
    min-height: 50rem;
    background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),url(/public/img/banniere.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 2rem;
    color: white;
    box-shadow: -5px 3px 15px rgba(0, 0, 0, 0.25);
    
    /* -webkit-mask-image: linear-gradient(180deg, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 95%);
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 95%);
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%; */
}

.pictogram{
  max-width: 2rem;
  filter:invert(0.9);
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
}

.link.active .pictogram {
  opacity: 1;
}

.banner-content {
    max-width: 800px;
    margin: 0 auto;
    padding: 3rem 0;
    border-radius: 20px;
}

.banner-content p {
  text-align: center;
    max-width: 430px;
    margin: 15px auto 35px auto;
}

.banner p,.banner h1 {
  padding:0 2px;
}

/* Navigation classique (visible sur les écrans larges) */
.desktop-navigation {
  display: flex;
}

.mobile-navigation {
  display: none;
}

/* Navigation responsive (visible sur les petits écrans) */
.mobile-links-container {
  display: flex;
  gap: 2vw;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
}

.mobile-link h3 {
  display: none;
}

@media screen and (max-width: 800px) {
  .desktop-navigation {
    display: none;
  }
  .mobile-navigation {
    display: block;
    width: 100%;
    text-align: center;
    margin-top: 1rem;
  }
  .mobile-links-container {
    padding: 1.5rem 0 !important;
  }
  .link{
    width: fit-content;
    padding:4px !important;
    border-radius: 4px;
  }
  .active{
    background: var(--yellow-white) !important;
    box-shadow: 0px 0px 0px 2px #141428, 0px 0px 0px 4px var(--yellow-white) !important;
  }
  .active img{
    filter: invert(0);
    opacity: 1;
  }
  .mobile-links-container {
    justify-content: space-evenly;
  }
  .custom-select {
    display: none;
  }
  .mobile-link {
    background: none;
    box-shadow: none;
    padding: 0.5rem;
  }
  .mobile-link .pictogram {
    max-width: 2.5rem;
    opacity: 0.7;
    transition: opacity 0.3s;
  }
  .mobile-link.active .pictogram,
  .mobile-link:hover .pictogram {
    opacity: 1;
  }
}

@media screen and (max-width: 505px) {
  .link{
    flex-direction: column;
  }
}

@media screen and (max-width: 400px) {
  .navigation .link p{
    font-size: 0.75rem;
  }
}

</style>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      routes: [
        { name: "Tous", path: "/portfolio/tous" },
        { name: "Audiovisuel", path: "/portfolio/audiovisuel" },
        { name: "Graphisme", path: "/portfolio/graphisme" },
        { name: "Développement web", path: "/portfolio/developpement-web" },
        { name: "UI-UX", path: "/portfolio/UI-UX" },
      ],
      transitionDirection: "forward",
      mobileInvertedIndex: localStorage.getItem("mobileInvertedIndex") !== null
        ? Number(localStorage.getItem("mobileInvertedIndex"))
        : null, // Ajouté
    };
  },
  watch: {
    $route(to, from) {
      const routesOrder = this.routes.map((route) => route.path);
      const toIndex = routesOrder.indexOf(to.path);
      const fromIndex = routesOrder.indexOf(from.path);

      this.transitionDirection = toIndex > fromIndex ? "forward" : "backward";
    },
  },
  methods: {
    handleClick(event, path) {
    this.moveBorder(event);
    this.$router.push(path);
  },
  moveBorder(event) {
    const target = event.currentTarget;
    const border = this.$refs.animatedBorder;
    const { offsetLeft, offsetWidth } = target;
    border.style.left = `${offsetLeft}px`;
    border.style.width = `${offsetWidth}px`;
  },
  getPictogram(routeName) {
    const icons = {
      Tous: "/img/pictogramme/tous.png",
      Audiovisuel: "/img/pictogramme/audiovisuel.png",
      Graphisme: "/img/pictogramme/graphisme.png",
      "Développement web": "/img/pictogramme/devWeb.webp",
      "UI-UX": "/img/pictogramme/ux-design.svg",
    };
    return icons[routeName] || "/path/to/default-icon.png"; 
  },
    updateBorderOnMount() {
      const activeRoute = this.$route.path;
      const linksContainer = this.$refs.linksContainer;
      if (linksContainer) {
        const links = linksContainer.querySelectorAll(".link");
        links.forEach((link) => {
          if (link.getAttribute("href") === activeRoute) {
            const event = { currentTarget: link };
            this.moveBorder(event);
          }
        });
      }
    },
    scrollToProjects() {
      const projectsSection = this.$refs.projectsSection;
      if (projectsSection) {
        projectsSection.scrollIntoView({ behavior: "smooth" });
      }
    },
    navigateTo(event) {
      const selectedPath = event.target.value;
      this.$router.push(selectedPath);
    },
    handleMobileClick(index, event, path) {
      this.mobileInvertedIndex = index;
      localStorage.setItem("mobileInvertedIndex", index);
      this.handleClick(event, path);
    },
  },
  mounted() {
    this.updateBorderOnMount();
    // Synchronise l'état au montage
    const saved = localStorage.getItem("mobileInvertedIndex");
    if (saved !== null) {
      this.mobileInvertedIndex = Number(saved);
    }
  },
};
</script>
